export default __webpack_public_path__ + "static/media/arrow_r.74b90040.svg";